export var PersonaName = /*#__PURE__*/function (PersonaName) {
  /**
   * The default persona. Trial subscription, Goal (prevent)
   */
  PersonaName["SOFIA"] = "SOFIA";
  /**
   * Annual subscription
   */
  PersonaName["ANA"] = "ANA";
  /**
   * Fahrenheit, imperial
   */
  PersonaName["FATIMA"] = "FATIMA";
  /**
   * Fahrenheit, metric
   */
  PersonaName["SUZANNA"] = "SUZANNA";
  /**
   * Demo mode (Prevent)
   */
  PersonaName["DEMIANA"] = "DEMIANA";
  /**
   * Demo mode (Plan)
   */
  PersonaName["DEMI_MOORE"] = "DEMI_MOORE";
  /**
   * Goal (Pregnant)
   */
  PersonaName["PEGGY"] = "PEGGY";
  /**
   * Goal (Plan)
   */
  PersonaName["FLORENCE"] = "FLORENCE";
  /**
   * Possibly pregnant
   */
  PersonaName["SONIA"] = "SONIA";
  /**
   * Pregnant while on prevent mode
   */
  PersonaName["VALENTINA"] = "VALENTINA";
  /**
   * Subscription expiring soon
   */
  PersonaName["ABACAXI_PRESENT"] = "ABACAXI_PRESENT";
  /**
   * Just renewed to future subscription
   */
  PersonaName["ABACAXI_FUTURE"] = "ABACAXI_FUTURE";
  /**
   * Subscription expired
   */
  PersonaName["ABACAXI_EXPIRED"] = "ABACAXI_EXPIRED";
  /**
   * Oura user
   */
  PersonaName["OLGA"] = "OLGA";
  /**
   * T2 user
   */
  PersonaName["VIOLET"] = "VIOLET";
  /**
   * T3 user
   */
  PersonaName["ELIZABETH"] = "ELIZABETH";
  /**
   * For performance testing. No popups in the app, 10 cycles of data
   */
  PersonaName["PERCY"] = "PERCY";
  /**
   * Just registered (no goal or subscription plan selected)
   */
  PersonaName["REGINA"] = "REGINA";
  /**
   * Just paid (to land in app onboarding)
   */
  PersonaName["BORINA"] = "BORINA";
  /**
   * Star cycler
   */
  PersonaName["STJARNA"] = "STJARNA";
  /**
   * Expecting withdrawal bleed
   */
  PersonaName["WHITNEY"] = "WHITNEY";
  /**
   * Apple Watch user
   */
  PersonaName["APPLETINA"] = "APPLETINA";
  /**
   * Goal (Postpartum)
   */
  PersonaName["PATRICIA"] = "PATRICIA";
  /**
   * Clearblue user
   */
  PersonaName["CLARISSA"] = "CLARISSA";
  /**
   * Pharmacy user
   */
  PersonaName["APOTEKINA"] = "APOTEKINA";
  /**
   * Samsung user
   */
  PersonaName["SAMANTHA"] = "SAMANTHA";
  /**
   * B1 user
   */
  PersonaName["B1LLIE"] = "B1LLIE";
  /**
   * No goal, no subscription user (for e2e testing of social sign up)
   */
  PersonaName["SOCIAL_SERENA"] = "SOCIAL_SERENA";
  /**
   * Persona for HCP users.
   * Goal history: Plan, Pregnant, Postpartum, Prevent
   */
  PersonaName["HANNA_CLARA"] = "HANNA_CLARA";
  /**
   * Goal (Perimenopause)
   */
  PersonaName["PERNILLA"] = "PERNILLA";
  return PersonaName;
}(PersonaName || {});